export const pesPathnamePageType = {
  SITE: 'site',
  ALL_PRODUCTS: 'all-products',
  BUSINESS: 'business',
  CATEGORY: 'product-category',
  SUBCATEGORY: 'product-subcategory',
  RANGE: 'product-range',
  PRODUCT: 'product',
} as const;

export const pesCatalogPageTypes = {
  ALL_PRODUCTS: 'all-products',
  CATEGORY: 'category',
  SUBCATEGORY: 'subcategory',
  RANGE: 'range',
  PRODUCT: 'product',
} as const;

export const pesPathnamePageTypeToPageTypeMap = {
  [pesPathnamePageType.ALL_PRODUCTS]: pesCatalogPageTypes.ALL_PRODUCTS,
  [pesPathnamePageType.CATEGORY]: pesCatalogPageTypes.CATEGORY,
  [pesPathnamePageType.SUBCATEGORY]: pesCatalogPageTypes.SUBCATEGORY,
  [pesPathnamePageType.RANGE]: pesCatalogPageTypes.RANGE,
  [pesPathnamePageType.PRODUCT]: pesCatalogPageTypes.PRODUCT,
} as const;

export const pesRouterNavigationType = {
  HASH: 'hash',
  PATH: 'path',
  EVENT: 'event',
} as const;
